export enum TableVerticalAlign {
  TOP = 'top',
  BOTTOM = 'bottom',
  MIDDLE = 'middle'
}
